<script setup lang="ts">
/**
 * Шапка публичных страниц.
 *
 * Общая на витрину и посадочные страницы: четыре копии одной шапки разъедутся
 * на первой же правке — где-то останется старая кнопка, где-то пропадёт ссылка.
 *
 * Навигация приходит снаружи, потому что она у страниц разная: на витрине это
 * якоря её собственных разделов, на посадочной — ссылки на соседние. Общая
 * навигация означала бы якорь на раздел, которого на этой странице нет.
 */
defineProps<{
  nav: { href: string; label: string }[];
}>();
</script>

<template>
  <header class="lp-topbar">
    <div class="lp-wrap lp-topbar__inner">
      <a href="/" class="lp-brand">
        <span class="lp-brand__mark">K</span>
        <span class="lp-brand__name">Keypi</span>
        <span class="lp-brand__tag">task → proposal</span>
      </a>
      <div class="lp-spacer" />
      <a v-for="item in nav" :key="item.href" :href="item.href" class="lp-navlink">
        {{ item.label }}
      </a>
      <!--
        Вход и регистрация живут в кабинете — другая точка входа и другой
        бандл. Поэтому обычные ссылки, а не RouterLink: переход между точками
        входа делает браузер.
      -->
      <a href="/login" class="lp-navlink">Войти</a>
      <a href="/register" class="lp-btn lp-btn--primary">Начать бесплатно</a>
    </div>
  </header>
</template>
